import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FileUp } from 'lucide-react';
import api from '../../../utils/authUtils';
import { Overlay, Modal, ModalTitle, ModalActions, Button, Message } from './ui';

// Just the upload step - what happens with the result (event confirmation,
// the created/duplicate/failed digest, letting the admin act on any of it)
// lives on SpeakerList.js now, not here. Every person the AI finds in any
// role - speaker, moderator, panelist, host, committee member - is imported
// immediately as an unqueued speaker draft (see
// SpeakerProfileService.importOneCandidate); a name that already matches an
// existing speaker draft, user, or account is skipped rather than creating a
// duplicate - a fuzzy, name-only warning, so it can miss real matches or
// flag near-namesakes (see docs/speaker-session-roles.md).
const ImportProgramModal = ({ open, onClose, onImported }) => {
  const intl = useIntl();
  const t = (id, def, values) => intl.formatMessage({ id, defaultMessage: def }, values);
  const [file, setFile] = useState(null);
  const [detecting, setDetecting] = useState(false);
  const [error, setError] = useState(null);

  if (!open) return null;

  const detect = async e => {
    e.preventDefault();
    if (!file) return;
    setDetecting(true); setError(null);
    try {
      const form = new FormData(); form.append('file', file);
      const { data } = await api.post('/api/cms/speaker-profiles/detect', form);
      onImported(data);
      setFile(null);
    } catch (err) {
      setError(err.response?.data || t('speakerMgmt.detect.failed', 'Could not detect speakers from this document.'));
    } finally { setDetecting(false); }
  };

  return (
    <Overlay onClick={() => !detecting && onClose()}>
      <Modal onClick={e => e.stopPropagation()}>
        <ModalTitle><FileUp size={18} /><FormattedMessage id="speakerMgmt.detect.title" defaultMessage="Import speakers from a program" /></ModalTitle>
        <p style={{ marginTop: 0, color: '#64748b', fontSize: '.9rem' }}>
          <FormattedMessage id="speakerMgmt.detect.subtitle" defaultMessage="Upload a program document (agenda, session grid, committee list). Everyone found is added as a new, not-yet-researched speaker draft for you to review at your own pace." />
        </p>
        {error && <Message error>{error}</Message>}
        <form onSubmit={detect}>
          <input type="file" accept="application/pdf" onChange={e => setFile(e.target.files?.[0] || null)} />
          <ModalActions style={{ marginTop: '1rem' }}>
            <Button secondary type="button" disabled={detecting} onClick={onClose}><FormattedMessage id="speakerMgmt.confirm.cancel" defaultMessage="Cancel" /></Button>
            <Button disabled={!file || detecting}><FileUp size={16} />{detecting
              ? <FormattedMessage id="speakerMgmt.detect.detecting" defaultMessage="Detecting…" />
              : <FormattedMessage id="speakerMgmt.detect.detect" defaultMessage="Detect speakers" />}</Button>
          </ModalActions>
        </form>
      </Modal>
    </Overlay>
  );
};

export default ImportProgramModal;
